
































import Vue from 'vue'

import { MasterlinkUserServiceProxy ,UserVO} from '@/service-proxies/app-v2/user.service-proxies'
const masterlinkUserService: MasterlinkUserServiceProxy = new MasterlinkUserServiceProxy;

export default Vue.extend({
  name: '',
  props:{
    visible: {
      type: Boolean,
      // 对象或数组默认值必须从一个工厂函数获取
      default: false
    },
    selectedUser:{
      type: Array,
      default:()=>[]
    },
    ok:{
      type: Function,
      default:()=>({})
    },
    cancel:{
      type: Function,
      default:()=>({})
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('page_role_management_full_name'),
          dataIndex: 'name',
          ellipsis: true
        },
        {
          title: this.$t('page_role_management_phone_number'),
          dataIndex: 'phone',
        },
        {
          title: this.$t('page_role_management_mailbox'),
          dataIndex: 'email',
        },
      ]
    }
  },
  components: {
  },
  filters: {
  },
  data() {
    return {
      pagination: {
        current:1,
        pageSize:5,
        total:0,
      },
      searchKey: undefined ,
      selectedRowKeys: [],
      usreList:[]
    }
  },
  methods: {
    handleOk(){
      this.$emit('ok',{
        userIdList:this.selectedRowKeys
      });
    },
    handleCancel(){
      this.$emit('cancel');
    },
    handleTableChange(pagination:any) {
        const pager = { ...this.pagination };
        pager.current = pagination.current;
        this.pagination = pager;
        this.userList();
    },
    handlesearch(value:string){
        this.searchKey = value;
        this.pagination.current=1;
        this.pagination.pageSize=5;
        this.userList();
    },
    onSelectChange(selectedRowKeys:any) {
      this.selectedRowKeys = selectedRowKeys;
    },
    userList(){
      masterlinkUserService.page(this.pagination.current,undefined,this.searchKey,this.pagination.pageSize)
        .then(res=>{
          if(res.data===undefined){
            return;
          }

          this.usreList = res.data.records;

          const pagination = { ...this.pagination };
          pagination.total = res.data.total;
          this.pagination = pagination;
      });
    }
  },
  created(){
  },
  watch:{
    visible(value){
      if(value){
        this.pagination.current=1;
        this.pagination.pageSize=5;
        this.pagination.total=0;
        this.searchKey=undefined;
        this.userList();
        return;
      }
    }
  }

})
